import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import styles from "@/styles/Process.module.scss";
import classnames from "classnames";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IconComplete = function IconComplete(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      cx: "30",
      cy: "30",
      r: "30",
      transform: "translate(2 2)",
      fill: "none",
      stroke: "#09f",
      strokeWidth: "3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.674,33.177,27.1,43.116l18.862-20",
      fill: "none",
      stroke: "#09f",
      strokeWidth: "3",
      fillOpacity: "0"
    })]
  }));
};

IconComplete.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64"
};

var IconExclamation = function IconExclamation(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      transform: "translate(-611 -228)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M29.048,15.844H34.33V36.97H29.048Zm2.641,32.349a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,31.689,48.194Z",
        transform: "translate(611.612 228)",
        fill: "#09f"
      }), /*#__PURE__*/_jsx("g", {
        transform: "translate(611 228)",
        children: /*#__PURE__*/_jsx("g", {
          transform: "translate(0 0)",
          children: /*#__PURE__*/_jsxs("g", {
            fill: "rgba(255,255,255,0)",
            stroke: "#09f",
            strokeWidth: "3",
            children: [/*#__PURE__*/_jsx("circle", {
              cx: "32",
              cy: "32",
              r: "32",
              stroke: "none"
            }), /*#__PURE__*/_jsx("circle", {
              cx: "32",
              cy: "32",
              r: "30.5",
              fill: "none"
            })]
          })
        })
      })]
    })
  }));
};

IconExclamation.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  viewBox: "0 0 64 64"
};
export default function ProcessInformation(_ref) {
  var _classnames;

  var complete = _ref.complete,
      icon = _ref.icon,
      header = _ref.header,
      children = _ref.children;
  var iconType = useMemo(function () {
    if (complete || icon === "complete") return "complete";
    return "excramation";
  }, [complete, icon]);
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.container, (_classnames = {}, _defineProperty(_classnames, styles.complete, complete), _defineProperty(_classnames, styles.information, !complete), _classnames)),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.inner,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.header,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.icon,
          children: [iconType === "complete" && /*#__PURE__*/_jsx(IconComplete, {}), iconType === "excramation" && /*#__PURE__*/_jsx(IconExclamation, {})]
        }), /*#__PURE__*/_jsx("h4", {
          className: styles.heading,
          children: header
        })]
      }), children]
    })
  });
}